export default "__VITE_ASSET__OevCo$qq__"